import { GENERATABLE_DOCUMENT_IDS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/constants.ts';

export const isDocumentGenerationAvailable = (
  documentId: string | number,
  isNewApplication: boolean,
  isFeatureEnabled: boolean
): boolean =>
  isNewApplication && isFeatureEnabled && GENERATABLE_DOCUMENT_IDS.has(String(documentId));
